import React, { Component } from "react";
import { Grid, Card, Button } from "tabler-react";
import { MapPin, Truck, Mail, Settings, Users } from "lucide-react";
import SiteWrapper from "../../SiteWrapper.react";
import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
import "./AdminstracionPage.css";

var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));

class AdminstracionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrastre: [],
      funcionalidades: []
    };
  }
  componentWillMount = () => {
    this.getfuntion("get", "", "", "funcionalidades/Administracion_Transportista/" + currentUser[0].perfil.id, "funcionalidades");
  }
  
  navigateTo = (url) => {
    window.location.href = url;
  }

  getfuntion = (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") => {
    Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
      switch (metodo) {
        case "get":
          {
            if (stateVar === "funcionalidades") {
              
              // Guardar funcionalidades completas
              this.setState({ funcionalidades: returnVal });
              
              let moduloArrastre = [];
              
              for(let item of returnVal){
                switch (item.nombre) {
                    case "Localidades": 
                      moduloArrastre.push(
                        <Grid.Col sm={6} lg={4} key="localidades">
                          <a href="/localidades" className="module-link">
                            <Card className="module-card">
                              <Card.Body>
                                <div className="icon-wrapper">
                                  <MapPin size={28} />
                                </div>
                                <h5>Localidades</h5>
                                <p>Gestiona ubicaciones</p>
                              </Card.Body>
                            </Card>
                          </a>
                        </Grid.Col>
                      );
                    break;
                    case "Remolques": 
                      moduloArrastre.push(
                        <Grid.Col sm={6} lg={4} key="remolques">
                          <a href="/remolques" className="module-link">
                            <Card className="module-card">
                              <Card.Body>
                                <div className="icon-wrapper">
                                  <Truck size={28} />
                                </div>
                                <h5>Remolques</h5>
                                <p>Catálogo de remolques</p>
                              </Card.Body>
                            </Card>
                          </a>
                        </Grid.Col>
                      );
                    break;
                    case "Tracto": 
                      moduloArrastre.push(
                        <Grid.Col sm={6} lg={4} key="tractos">
                          <a href="/tractos" className="module-link">
                            <Card className="module-card">
                              <Card.Body>
                                <div className="icon-wrapper">
                                  <Truck size={28} />
                                </div>
                                <h5>Tractos</h5>
                                <p>Catálogo de tractos</p>
                              </Card.Body>
                            </Card>
                          </a>
                        </Grid.Col>
                      );
                    break;
                    case "correos_notificaciones_transportistas":
                      moduloArrastre.push(
                        <Grid.Col sm={6} lg={4} key="correos">
                          <a href="/correosNotificaciones" className="module-link">
                            <Card className="module-card">
                              <Card.Body>
                                <div className="icon-wrapper">
                                  <Mail size={28} />
                                </div>
                                <h5>Notificaciones</h5>
                                <p>Configurar correos</p>
                              </Card.Body>
                            </Card>
                          </a>
                        </Grid.Col>
                      );
                    break;
                    case "Operadores":
                      moduloArrastre.push(
                        <Grid.Col sm={6} lg={4} key="operadores">
                          <a href="/catalogo-operadores" className="module-link">
                            <Card className="module-card">
                              <Card.Body>
                                <div className="icon-wrapper">
                                  <Users size={28} />
                                </div>
                                <h5>Operadores</h5>
                                <p>Inofrmación de operadores</p>
                              </Card.Body>
                            </Card>
                          </a>
                        </Grid.Col>
                      );
                    break;
                  default:
                    break;
                }
              }
              
              this.setState({arrastre: moduloArrastre});
            }
          }
          break;
        default:
          break;
      }
    }).catch(err => { console.log("Error desconocido ...."+ err); })
  }
  render(){
    return (
      <SiteWrapper>
        <div className="admin-container">
          <div className="admin-header">
            <Settings size={28} className="header-icon" />
            <div>
              <h2 className="admin-title">Panel de Administración</h2>
              <p className="admin-subtitle">Gestiona la configuración del sistema</p>
            </div>
          </div>

          { this.state.arrastre.length > 0 ? (
            <div className="modules-grid">
              <Grid.Row className="justify-content-center">
                {this.state.arrastre}
              </Grid.Row>
            </div>
          ) : (
            <div className="modules-grid">
              <Grid.Row className="justify-content-center">
                {[...Array(3)].map((_, index) => (
                  <Grid.Col sm={6} lg={4} key={`skeleton-${index}`}>
                    <Card className="module-card skeleton-card">
                      <Card.Body>
                        <div className="skeleton-icon-wrapper">
                          <div className="skeleton-icon"></div>
                        </div>
                        <div className="skeleton-title"></div>
                        <div className="skeleton-subtitle"></div>
                      </Card.Body>
                    </Card>
                  </Grid.Col>
                ))}
              </Grid.Row>
            </div>
          )}
        </div>
      </SiteWrapper>
    );
  }
}
export default AdminstracionPage;
